import { Badge as MantineBadge } from "@mantine/core";
export const Badge = MantineBadge.extend({
  styles: () => ({
    root: {
      textTransform: "none",
    },
  }),
});
